import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatSelectionListChange } from '@angular/material/list/selection-list';
import { Category, CategoryEvents, CategoryTags, HofcategoryHallOfFame } from 'app/categories/category';
import { CategoryEventsService } from 'app/_services/category-events.service';
import { CategoryHOFService } from 'app/_services/category-hof.service';
import { NotificationService } from 'app/_services/notification.service';

export enum CategoryTypes {
    CalendarEvents = 'calendarEvents',
    HallOfFame = 'hof',
}
@Component({
    selector: 'app-category-tags',
    templateUrl: './category-tags.component.html',
    styleUrls: ['./category-tags.component.scss'],
})
export class CategoryTagsComponent implements OnInit, AfterViewInit {
    @Input() categories: any[];
    @Input() categoryNames: string[];
    @Input() itemCategories: any;
    @Input() items: any;
    @Input() itemName: string;
    @Input() itemId: number;
    @Input() categoryType: string;
    @Output() clickedItem = new EventEmitter<string>();
    categoriesControl: FormControl;

    constructor(
        private cd: ChangeDetectorRef,
        private catEventService: CategoryEventsService,
        private catHOFService: CategoryHOFService,
        private notificationService: NotificationService
    ) {}

    ngOnInit(): void {
        const categories = this.mapCategories(this.categoryType, this.itemCategories);
        this.categoriesControl = new FormControl(categories);
    }

    ngAfterViewInit() {
        this.cd.detectChanges();
    }

    onCategoryRemoved(category: CategoryTags): void {
        const categoryTags = this.categoriesControl.value as CategoryTags[];

        const index = categoryTags.indexOf(category);

        if (index >= 0) {
            categoryTags.splice(index, 1);
        }

        this.categoriesControl.setValue(categoryTags); // To trigger change detection
        this.removeCategory(this.categoryType, category);
    }

    updateCategoryTags(event?: MatSelectionListChange): void {
        if (event.option.selected) {
            this.addCategory(this.categoryType, event.option.value);
        } else {
            this.removeCategory(this.categoryType, event.option.value);
        }
    }

    cssClass(category: string): string {
        return 'catChip-' + category.trim().replace(/\s+/g, '-').toLowerCase();
    }

    // Compare function will autmatically compare the FormControl values with the list of categories
    compare(c1: { name: string }, c2: { name: string }) {
        return c1 && c2 && c1.name === c2.name;
    }

    mapCategories(type: string, categories: any): CategoryTags | null {
        switch (type) {
            case categories && CategoryTypes.CalendarEvents:
                return categories.map((cat: Category) => new CategoryTags(cat.name, cat.categoryId));
            case categories && CategoryTypes.HallOfFame:
                return categories.map(
                    (cat: HofcategoryHallOfFame) => new CategoryTags(cat.hofcategory.categoryName, cat.hofcategoryId)
                );
            default:
                return null;
        }
    }

    addCategory(type: string, category: any) {
        switch (type) {
            case CategoryTypes.CalendarEvents: {
                const newCategoryEvent: CategoryEvents = {
                    categoryEventId: 0, // Set to 0 since this is set to Identity column in database
                    eventId: this.itemId,
                    categoryId: category.id,
                };
                return this.catEventService.createCategoryEvent(newCategoryEvent).subscribe();
            }

            case CategoryTypes.HallOfFame: {
                const newHofcategoryHallOfFame: HofcategoryHallOfFame = {
                    hofcategoryHallOfFameId: 0, // Set to 0 since this is set to Identity column in database
                    hallOfFameId: this.itemId,
                    hofcategoryId: category.id,
                };
                return this.catHOFService.createHofcategoryHallOfFame(newHofcategoryHallOfFame).subscribe();
            }

            default: {
                return this.notificationService.showError('ERROR: Update failed due to incorrect category type.');
            }
        }
    }

    removeCategory(type: string, category: any) {
        const masterItemId = this.itemId;

        switch (type) {
            case CategoryTypes.CalendarEvents: {
                this.catEventService.getCategoryEventsByEventId(masterItemId).subscribe((categoryEvents) => {
                    let catEvent = categoryEvents.find((ce: CategoryEvents) => ce.categoryId === category.id);
                    return this.catEventService.deleteCategoryEvent(catEvent.categoryEventId).subscribe();
                });
                return;
            }

            case CategoryTypes.HallOfFame: {
                this.catHOFService.getHofcategoryHallOfFamesByHallOfFameId(masterItemId).subscribe((hofcategoryHallOfFames) => {
                    let hofCatHallOfFame = hofcategoryHallOfFames.find(
                        (chof: HofcategoryHallOfFame) => chof.hofcategoryId === category.id
                    );
                    return this.catHOFService.deleteHofcategoryHallOfFame(hofCatHallOfFame.hofcategoryHallOfFameId).subscribe();
                });

                return;
            }

            default: {
                this.notificationService.showError('ERROR: Deletion Failed.');
            }
        }
    }
}
